// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/lib/style.css
// module id = 645
// module chunks = 0